<div class="ade-listing flex flex-col w-full">
  <!-- Widgets de conteúdo da page -->
  <ng-container *ngFor="let widget of widgets">
    <ng-container *ngIf="widget.__component === 'widgets.banner'">
      <widget-banner [widget]="widget"></widget-banner>
    </ng-container>

    <div class="ade-listing__container">
      <ng-container *ngIf="widget.__component === 'widgets.image'">
        <div class="ade-listing__widget">
          <widget-image [widget]="widget"></widget-image>
        </div>
      </ng-container>

      <!-- <ng-container *ngIf="widget.__component === 'widgets.block-title'">
        <div class="ade-listing__widget"><widget-title [widget]="widget"></widget-title></div>
      </ng-container> -->

      <ng-container
        *ngIf="widget.__component === 'widgets.block-title-description'"
      >
        <div class="ade-listing__widget">
          <widget-block-title-description
            [widget]="widget"
          ></widget-block-title-description>
        </div>
      </ng-container>

      <ng-container *ngIf="widget.__component === 'widgets.editor-text'">
        <div class="ade-listing__widget">
          <widgets-editor-text [widget]="widget"></widgets-editor-text>
        </div>
      </ng-container>

      <ng-container
        *ngIf="widget.__component === 'widgets.block-simple-long-text'"
      >
        <div class="ade-listing__widget ade-listing__text">
          {{ widget.text }}
        </div>
      </ng-container>

      <ng-container *ngIf="widget.__component === 'widgets.block-quote'">
        <div class="ade-listing__widget ade-listing__quote">
          {{ widget.description }}
        </div>
      </ng-container>

      <ng-container *ngIf="widget.__component === 'shared.title'">
        <div class="ade-listing__widget">
          <h1
            [style.text-align]="widget.textAlign || 'center'"
            style="
              font-size: 48px;
              text-transform: uppercase;
              font-weight: 300;
              font-style: normal;
              text-decoration: none;
              letter-spacing: 5px;
              font-family: &quot;Lato&quot;, serif !important;
              font-size: 32px !important;
              color: var(--ade-gold-meta, #ab9311) !important;
            "
          >
            {{ widget.title }}
          </h1>
        </div>
      </ng-container>

      <ng-container *ngIf="widget.__component === 'shared.text'">
        <div
          class="ade-listing__widget ade-listing__text"
          [style.text-align]="widget.textAlign || 'left'"
          [innerHTML]="widget.text || widget.body"
        ></div>
      </ng-container>

      <ng-container *ngIf="widget.__component === 'widgets.text'">
        <div class="ade-listing__widget">
          <widget-text [widget]="widget"></widget-text>
        </div>
      </ng-container>
    </div>

    <ng-container
      *ngIf="widget.__component === 'widgets.section-image-title-text'"
    >
      <widgets-image-title-text [widget]="widget"></widgets-image-title-text>
    </ng-container>

    <div class="ade-listing__container">
      <ng-container *ngIf="widget.__component === 'widgets.gallery'">
        <div class="ade-listing__widget">
          <widget-gallery [widget]="widget"></widget-gallery>
        </div>
      </ng-container>

      <ng-container *ngIf="widget.__component === 'widgets.video'">
        <div class="ade-listing__widget">
          <widget-video [widget]="widget"></widget-video>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <div class="ade-listing__content-grid flex flex-col w-full">
    <!-- Título da listagem (fallback se não houver widgets)
    <div class="ade-listing__header" *ngIf="title && (!widgets || widgets.length === 0)">
      <h1 class="ade-listing__title">{{ title | transloco }}</h1>
      <p class="ade-listing__subtitle" *ngIf="subtitle">{{ subtitle | transloco }}</p>
    </div> -->

    <div
      class="ade-listing__inner flex flex-col max-w-screen-lg w-full mx-auto"
    >
      <div class="ade-listing__loading" *ngIf="isLoading">
        <mat-spinner diameter="48"></mat-spinner>
      </div>

      <div
        class="ade-listing__empty"
        *ngIf="!isLoading && vehicles.length === 0"
      >
        {{ "Sem veículos disponíveis." | transloco }}
      </div>

      <div
        class="ade-listing__grid"
        [style.--cols]="columns"
        *ngIf="!isLoading && vehicles.length > 0"
      >
        <ade-classified-card
          *ngFor="let v of vehicles"
          [item]="v"
        ></ade-classified-card>
      </div>

      <div class="ade-listing__pagination" *ngIf="!isLoading && pageCount > 1">
        <button
          class="ade-listing__page-btn"
          type="button"
          [disabled]="page === 1"
          (click)="goToPage(page - 1)"
        >
          {{ "ANTERIOR" | transloco }}
        </button>

        <span class="ade-listing__page-info">{{ page }} / {{ pageCount }}</span>

        <button
          class="ade-listing__page-btn"
          type="button"
          [disabled]="page === pageCount"
          (click)="goToPage(page + 1)"
        >
          {{ "SEGUINTE" | transloco }}
        </button>
      </div>
    </div>
  </div>
</div>
